// extracted by mini-css-extract-plugin
module.exports = {"root":"Skeleton_root__2Lhvr","shimmer":"Skeleton_shimmer__2oU2x"};